import { render, staticRenderFns } from "./tdColTooltip.vue?vue&type=template&id=a71c624c&"
import script from "./tdColTooltip.vue?vue&type=script&lang=js&"
export * from "./tdColTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports